// Copyright (c) 2019 Verimatrix, Inc.  All Rights Reserved.

import {
  ACTIVATE_USER,
  USER_ACTIVATED
} from '../actions/user'

const initialState = {
  username: null,
  password: null,
}

export default function (state = initialState, action) {
  switch (action.type) {
    case ACTIVATE_USER:
      return {...state, username: action.payload.username, password: action.payload.password}
    case USER_ACTIVATED:
      return {...state, username: null, password: null}
    default:
      return state
  }
}

